import { GR_ENV } from 'src/constants'
import { getConfig } from 'src/config'

const config = getConfig()

export const ninetailedConfig = {
  clientId: config.ninetailed.clientId,
  environment: GR_ENV === 'prod' || GR_ENV === 'preprod' ? 'main' : 'development',
}
